import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { removeLoading, setLoading } from '../reducer/loaderSlice';
import { refreshAlumniAttendanceData, setAlumniData, refreshAlumniTicketData } from '../reducer/aluminiSlice';
import { sagaActions } from '../sagaActions';
import { jwtHeader } from '../../utils/AuthManager';
import { toast } from 'react-toastify';

function* fetchAlumniData() {
  try {
    yield put(setLoading());
    const response = yield call(() => axios.get(`${process.env.REACT_APP_BACKEND_FASTAPI_ENDPOINT}/registration/all`, {
      headers: jwtHeader()
    }).then((res) => res));
    if (response?.status === 200) {
      yield put(setAlumniData({studentData: response.data, error: ''}));
    } else {
      yield put(setAlumniData({studentData: [], error: 'Data not found'}));
    }
  } catch (error) {
    yield put(setAlumniData({studentData: [], error: error.message}));
  } finally {
    yield put(removeLoading());
  }
}

function* updateAlumniAttendance(action) {
  try {
    yield put(setLoading());

    const {registration_id, attendance_status, comment, callback, setSearchString} = action.payload;
    const requestData = {registration_id, att_status_id: attendance_status.att_status_id, comment};

    const response = yield call(() => axios.put(`${process.env.REACT_APP_BACKEND_FASTAPI_ENDPOINT}/registration/update/attendance`, requestData, {
      headers: jwtHeader(),
    }).then((res) => res));

    if (response?.status === 200) {
      yield put(refreshAlumniAttendanceData(response.data));
      callback();
      setSearchString("");
      toast.success("Update Success");
    } else {
      toast.error('Something went during update');
    }
  } catch (error) {
    toast.error(error.message);
  } finally {
    yield put(removeLoading());
  }
}

function* updateAlumniTicketStatus(action) {
  try {
    yield put(setLoading());

    const {registration_id, ticket_status, callback, setSearchString} = action.payload;
    const requestData = {registration_id, ticket_status_id: ticket_status.ticket_status_id};
    const response = yield call(() => axios.put(`${process.env.REACT_APP_BACKEND_FASTAPI_ENDPOINT}/registration/update/ticket`, requestData, {
      headers: jwtHeader(),
    }).then((res) => res));
    if (response?.status === 200) {
      yield put(refreshAlumniTicketData(response.data));
      callback();
      setSearchString("");
      toast.success("Ticket status has been updated");
    } else {
      toast.error('Something went during update');
    }
  }
  catch (err) {
    toast.error(err.message);
  }
  finally {
    yield put(removeLoading());
  }
}

export default function* alumniSaga() {
  yield takeLatest(sagaActions.FETCH_ALUMNI_DATA, fetchAlumniData);
  yield takeLatest(sagaActions.UPDATE_ALUMNI_STATUS, updateAlumniAttendance);
  yield takeLatest(sagaActions.UPDATE_ALUMNI_TICKET_STATUS, updateAlumniTicketStatus)
}